import { Tooltip } from 'antd';
const CustomTooltip = ({ ...props}) => {
    return <Tooltip {...props} color="#3f4957">
    </Tooltip>;
  };
export default CustomTooltip;
